import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonGroup, Confirm } from 'semantic-ui-react';

type ActionsProps = {
  showEdit?: boolean;
  showEnable?: boolean;
  showDetails?: boolean;
  isDisabled?: boolean;
  onEdit?: any;
  onDisable?: any;
  detailsLink?: string;
  vertical?: boolean;
};

const Actions = (props: ActionsProps) => {
  const {
    isDisabled,
    showEdit,
    showDetails,
    showEnable,
    detailsLink,
    vertical = true,
    onDisable,
    onEdit,
  } = props;

  const [isConfirmOpen, setConfirmOpen] = useState(false);

  const handleOpenConfirm = () => {
    setConfirmOpen(true);
  };

  const handleCancel = () => {
    setConfirmOpen(false);
  };

  const handleConfirm = () => {
    if (onDisable) {
      onDisable();
    }
    setConfirmOpen(false);
  };

  return (
    <>
      <ButtonGroup size="tiny" vertical={vertical}>
        {showEdit && <Button onClick={onEdit}>Edit</Button>}
        {showEnable && (
          <Button onClick={handleOpenConfirm}>
            {isDisabled ? 'Enable' : 'Disable'}
          </Button>
        )}
        {showDetails && detailsLink && (
          <Button as={Link} to={detailsLink}>
            View Details
          </Button>
        )}
      </ButtonGroup>

      <Confirm
        open={isConfirmOpen}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        content={`Are you sure you want to ${
          isDisabled ? 'enable' : 'disable'
        } this item?`}
        confirmButton={isDisabled ? 'Enable' : 'Disable'}
        cancelButton="Cancel"
        size="mini"
      />
    </>
  );
};

export default Actions;
